import { useQuery } from '@tanstack/react-query'

import { FailureEnvelop, GetShortLabelListViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetLabels = () => {
    const { data, isLoading } = useQuery<GetShortLabelListViewModel, FailureEnvelop>({
        queryKey: QueryKeys.Interactify.Labels,
        queryFn: () =>
            fetchRequest({
                endpoint: '/videos/short-video/labels',
                method: 'GET',
                serviceName: 'cml',
            }),
        staleTime: Infinity,
    })

    return { data: data?.labels || [], isLoading }
}
